import React from 'react';
import { Select } from 'antd';
import { WebsiteIndexEntry } from '../../deepAnalysis/websiteIndexEntry/types';
import useUrlState from '../../hooks/useUrlState';

const { Option } = Select;

type Props = {
    trackedWebsites: WebsiteIndexEntry[];
    selectedWebsite: WebsiteIndexEntry | undefined;
};

export default function TrackedWebsiteSelector({ trackedWebsites, selectedWebsite }: Props) {
    const [, setUrlState] = useUrlState();
    const handleSelectedWebsiteGuidChange = (newSelectedWebsiteGuid: string) => {
        setUrlState({ w_guid: newSelectedWebsiteGuid });
    };

    return (
        <Select
            className="tracked-website-selector"
            size="large"
            value={selectedWebsite ? selectedWebsite.guid : ''}
            onChange={handleSelectedWebsiteGuidChange}
        >
            {trackedWebsites.map((trackedWebsite) => (
                <Option
                    value={trackedWebsite.guid}
                    key={trackedWebsite.guid}
                >
                    {trackedWebsite.domain}
                </Option>
            ))}
        </Select>
    );
}
